export const DownloadType = {
    PDF_RECEIPT : "PDF_RECEIPT",
    EXCEL_RECEIPT : "EXCEL_RECEIPT",
    XML_SUMMARY : "XML_SUMMARY",
    XML_DETAILS : "XML_DETAILS",
    MEDICAL_TRANSFER : "MEDICAL_TRANSFER"
};